export default "__VITE_ASSET__Cyb0Xg9r__"